import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-iconPark-monitor-off",
  "use": "icon-iconPark-monitor-off-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-iconPark-monitor-off\">\r\n    <rect width=\"48\" height=\"48\" fill=\"#101010\" fill-opacity=\"0.01\" stroke=\"none\" /><path d=\"M4 12V38H20H28H30M18 10H20H36V24V27\" stroke=\"#101010\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44 14L36 20.75V27.25L44 34V14Z\" stroke=\"#101010\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" /><path d=\"M44 44L4 4\" stroke=\"#101010\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/iconPark-monitor-off.svg
// module id = RPtW
// module chunks = 24